export function displaySlot(
  slotNumber: number,
  productCount: number,
  slotsKeys: number[],
  schema: Record<number, number>
): boolean {
  const previousSlotCount = countLessThan(slotsKeys, slotNumber);

  return productCount + previousSlotCount >= schema[slotNumber];
}

export function displayMiddleBannerWithSlots(
  bannerNumber: number,
  productCount: number,
  slotsKeys: number[],
  schema: Record<number, number[]>
): boolean {
  const bannerData = schema[bannerNumber];
  const previousLastSlotExpected = bannerData[1];
  const previousSlotCount = countLessThan(slotsKeys, previousLastSlotExpected);

  return productCount + previousSlotCount >= bannerData[0];
}

export function displayBigProduct(
  bigProductNumber: number,
  productCount: number,
  bigProductsKeys: number[],
  schema: Record<number, number>
): boolean {
  const previousBigProductCount = countLessThan(
    bigProductsKeys,
    bigProductNumber
  );

  return productCount + previousBigProductCount >= schema[bigProductNumber];
}

export function displayMiddleBannerWithBigProducts(
  bannerNumber: number,
  productCount: number,
  bigProductsKeys: number[],
  schema: Record<number, number[]>
): boolean {
  const bannerData = schema[bannerNumber];
  const previousLastBigProductExpected = bannerData[1];
  const previousBigProductCount = countLessThan(
    bigProductsKeys,
    previousLastBigProductExpected
  );

  return productCount + previousBigProductCount * 4 >= bannerData[0];
}

function countLessThan(arr, threshold) {
  return arr.filter(num => num <= threshold).length;
}
